import(/* webpackMode: "eager" */ "/vercel/path0/app/channels/[id]/page.tsx");
